import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
    container:{
        width: '100%',
        padding: '15px',
        fontSize: '1em',
        justifyContent: 'center',
        display: 'flex',
        alignItems: 'center'
    },
    body:{
        paddingTop: '5px'   
    },
    icon:{
        color: '#f3cb19',
        fontSize: '1em'
    }
}));

export default useStyles;
